"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const a=require("./index313.js");require("./index5.js");const o=require("@apollo/client");function c(e){const t=Object.create(null,{[Symbol.toStringTag]:{value:"Module"}});if(e){for(const n in e)if(n!=="default"){const s=Object.getOwnPropertyDescriptor(e,n);Object.defineProperty(t,n,s.get?s:{enumerable:!0,get:()=>e[n]})}}return t.default=e,Object.freeze(t)}const i=c(o);var r,l={},u=o.gql(r||(r=a.default([`
  query inProductMessages($input: InProductMessagesInput!) {
    inProductMessages(input: $input) {
      items {
        content
        sentAt
        id
        isRead
        campaignName
      }
      cursorInfo {
        lastMessageId
      }
      totalCount
    }
  }
`])));function d(e){var t=Object.assign({},l,e);return i.useQuery(u,t)}exports.InProductMessagesDocument=u;exports.useInProductMessagesQuery=d;
